<template>
  <div v-loading="loading" class="vg_wrapper">
    <el-card>
      <div v-if="activeTab !== '出错纠错统计'" class="button-container vg_mb_5">
        <button
          v-for="(btn, index) in buttons"
          :key="index"
          :class="['jobsBorder', 'el-button', 'el-button--default', { 'active-button': module === btn }]"
          @click="changeModule(btn)"
        >
          {{ btn === '备料' ? btn + '(出库)' : btn }}
        </button>
      </div>
      <div v-else class="button-container2 vg_mb_5">
        <button
          v-for="(btn, index) in buttons2"
          :key="index"
          :class="['jobsBorder', 'el-button', 'el-button--default', { 'active-button': module2 === btn }]"
          @click="changeModule(btn)"
        >
          {{ btn }}
        </button>
      </div>
      <el-button class="buttonText" round size="mini" type="primary" @click="openStyleDialog">查看式样数据</el-button>
      <el-tabs v-model="activeTab" type="border-card" @tab-click="val => changeModule(activeTab !== '出错纠错统计' ? module : module2)">
        <el-tab-pane label="工作量统计" name="工作量统计">
          <el-row>
            <el-col :span="24" style="margin-bottom: 20px; margin-top: 10px">
              <div class="diagramTitle">
                <span style="font-size: 20px; margin-right: 10px">统计时间:</span>
                <div class="dateSelect">
                  <el-date-picker v-model="daytime[0]" type="date"> </el-date-picker>
                  <span style="font-size: 20px">至</span>
                  <el-date-picker v-model="daytime[1]" type="date"> </el-date-picker>
                </div>
                <el-button class="buttonText" round size="mini" @click="timeScope(1)">近一月</el-button>
                <el-button class="buttonText" round size="mini" @click="timeScope(3)">近三月</el-button>
                <el-button class="buttonText" round size="mini" @click="timeScope(6)">近六月</el-button>
                <el-button class="buttonText" round size="mini" @click="timeScope(0)">全部</el-button>
                <el-button class="buttonText" round size="mini" type="primary" @click="getTableData()">查询</el-button>
                <el-button class="buttonText" round size="mini" type="info" @click="refresh">刷新</el-button>
                <el-button class="buttonText" round size="mini" type="success" @click="exportToExcel">导出Excel</el-button>
                <el-button v-if="module === '手工'" class="buttonText" round size="mini" type="warning" @click="dialogVisible = true"
                  >难度系数调整
                </el-button>
              </div>
            </el-col>
            <el-col :span="24">
              <open v-show="module === '开版'" ref="开版" :tableData="tableData" @getTableData="getTableData"></open>
              <stap v-show="module === '印花'" ref="印花" :tableData="tableData" @getTableData="getTableData"></stap>
              <emcd v-show="module === '制卡'" ref="制卡" :tableData="tableData" @getTableData="getTableData"></emcd>
              <lase v-show="module === '激光'" ref="激光" :tableData="tableData" @getTableData="getTableData"></lase>
              <embr v-show="module === '电绣'" ref="电绣" :tableData="tableData" @getTableData="getTableData"></embr>
              <HandCut v-show="module === '手裁'" ref="手裁" :tableData="tableData" @getTableData="getTableData"></HandCut>
              <stpr v-show="module === '备料'" ref="备料" :tableData="tableData" @getTableData="getTableData"></stpr>
              <comp v-show="module === '复合'" ref="复合" :tableData="tableData" @getTableData="getTableData"></comp>
              <mase v-show="module === '机缝'" ref="机缝" :tableData="tableData" @getTableData="getTableData"></mase>
              <manu v-show="module === '手工'" ref="手工" :tableData="tableData" @getTableData="getTableData"></manu>
              <insp v-show="module === '检验'" ref="检验" :tableData="tableData" @getTableData="getTableData"></insp>
              <inbound v-show="module === '入库'" ref="入库" :tableData="tableData" @getTableData="getTableData"></inbound>
              <quotation v-show="module === '报价'" ref="报价" :tableData="tableData" @getTableData="getTableData"></quotation>
              <dataEntry v-show="module === '数据录入'" ref="数据录入" :tableData="tableData" @getTableData="getTableData"></dataEntry>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="出错纠错统计" name="出错纠错统计">
          <CorrectionStatistics ref="correctionStatisticsRef" :module="module2"></CorrectionStatistics>
        </el-tab-pane>
        <el-tab-pane label="工作绩效统计" name="工作绩效统计">
          <PerformanceStatistics ref="performanceStatisticsRef" :module="module"></PerformanceStatistics>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <el-dialog :visible.sync="dialogVisible" title="难度系数调整" top="0" width="50%">
      <search-table
        ref="searchTable"
        :columnMove="false"
        :columns="dialogTableProperties"
        :data="dialogTableData"
        :fixedHeightParam="400"
        :need-fixed-height="false"
        :need-pagination="false"
        :need-search="false"
        :tableRowKey="'id'"
      />
      <div class="vg_mt_8" style="display: flex">
        <el-button class="buttonText" round size="mini" style="margin-left: auto" type="danger" @click="editDiffListData">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="styleDialogVisible" title="式样数据" top="0" width="60%">
      <div class="diagramTitle vg_mb_5">
        <span style="font-size: 20px; margin-right: 10px">统计时间:</span>
        <div class="dateSelect">
          <el-date-picker v-model="styleDaytime[0]" type="date"> </el-date-picker>
          <span style="font-size: 20px">至</span>
          <el-date-picker v-model="styleDaytime[1]" type="date"> </el-date-picker>
        </div>
        <el-button class="buttonText" round size="mini" @click="styleTimeScope(1)">上月</el-button>
        <el-button class="buttonText" round size="mini" @click="styleTimeScope(3)">近三月</el-button>
        <el-button class="buttonText" round size="mini" @click="styleTimeScope(6)">近六月</el-button>
        <el-button class="buttonText" round size="mini" type="primary" @click="styleGetTableData()">查询</el-button>
      </div>
      <el-alert
        title="委托接收单 接收的时间，默认给到上个月，默认为上个月的26号~这个月的25号"
        type="warning"
        :closable="false"
        show-icon
        class="vg_mb_5"
      />
      <el-tabs v-model="styleDialogActiveTab" type="border-card" @tab-click="handleStyleTabClick">
        <el-tab-pane label="手裁" name="手裁">
          <search-table
            ref="styleHandCutTable"
            :columnMove="false"
            :columns="styleDialogColumns"
            :data="styleHandCutData"
            :fixedHeightParam="400"
            :need-fixed-height="false"
            :need-pagination="false"
            :need-search="true"
            :tableRowKey="'id'"
            @getTableData="() => styleGetTableData('handCut')"
          />
        </el-tab-pane>
        <el-tab-pane label="机缝" name="机缝">
          <search-table
            ref="styleMaseTable"
            :columnMove="false"
            :columns="styleDialogColumns"
            :data="styleMaseData"
            :fixedHeightParam="400"
            :need-fixed-height="false"
            :need-pagination="false"
            :need-search="true"
            :tableRowKey="'id'"
            @getTableData="() => styleGetTableData('mase')"
          />
        </el-tab-pane>
        <el-tab-pane label="手工" name="手工">
          <search-table
            ref="styleManuTable"
            :columnMove="false"
            :columns="styleDialogColumns"
            :data="styleManuData"
            :fixedHeightParam="400"
            :need-fixed-height="false"
            :need-pagination="false"
            :need-search="true"
            :tableRowKey="'id'"
            @getTableData="() => styleGetTableData('manu')"
          />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import { get, getNoCatch, postNoCatch } from '@api/request';
import { dataStaticsAPI } from '@api/modules/stat';
import Open from '@/views/DataStatistics/ProductValueYieldStatistics/TabChild/Open';
import Stap from '@/views/DataStatistics/ProductValueYieldStatistics/TabChild/Stap';
import HandCut from '@/views/DataStatistics/ProductValueYieldStatistics/TabChild/HandCut';
import Stpr from '@/views/DataStatistics/ProductValueYieldStatistics/TabChild/Stpr';
import Lase from '@/views/DataStatistics/ProductValueYieldStatistics/TabChild/Lase';
import Comp from '@/views/DataStatistics/ProductValueYieldStatistics/TabChild/Comp';
import Embr from '@/views/DataStatistics/ProductValueYieldStatistics/TabChild/Embr';
import Emcd from '@/views/DataStatistics/ProductValueYieldStatistics/TabChild/Emcd';
import Mase from '@/views/DataStatistics/ProductValueYieldStatistics/TabChild/Mase';
import Manu from '@/views/DataStatistics/ProductValueYieldStatistics/TabChild/Manu';
import Insp from '@/views/DataStatistics/ProductValueYieldStatistics/TabChild/Insp.vue';
import Inbound from '@/views/DataStatistics/ProductValueYieldStatistics/TabChild/Inbound.vue';
import Quotation from '@/views/DataStatistics/ProductValueYieldStatistics/TabChild/Quotation.vue';
import DataEntry from '@/views/DataStatistics/ProductValueYieldStatistics/TabChild/DataEntry.vue';
import CorrectionStatistics from '@/views/DataStatistics/ProductValueYieldStatistics/TabChild/CorrectionStatistics.vue';
import PerformanceStatistics from '@/views/DataStatistics/ProductValueYieldStatistics/TabChild/PerformanceStatistics.vue';
import { cloneDeep } from 'lodash';
import SearchTable from '@/components/SearchTableV3.vue';
import { keep1Decimal, keepNumber } from '@assets/js/regExUtil';
import {
  buttons,
  buttons2,
  dialogProperties,
  eChatsOptions1,
  eChatsOptions2,
  styleDialogColumns
} from '@/views/DataStatistics/ProductValueYieldStatistics/pvys';

export default {
  name: 'ProductValueYieldStatistics',
  components: {
    SearchTable,
    Open,
    Stap,
    Emcd,
    Lase,
    Embr,
    HandCut,
    Stpr,
    Comp,
    Mase,
    Manu,
    Insp,
    Inbound,
    Quotation,
    DataEntry,
    CorrectionStatistics,
    PerformanceStatistics
  },
  data() {
    return {
      allTableData: [],
      currentPage: 1,
      loading: false,
      daytime: '',
      option: eChatsOptions1,
      option2: eChatsOptions2,
      tableData: [],
      totalPage: 0,
      startTime: '',
      endTime: '',
      module: '开版',
      module2: '开版师',
      dialogVisible: false,
      dialogTableData: [],
      dialogTableProperties: dialogProperties,
      buttons: buttons,
      buttons2: buttons2,
      activeTab: '工作量统计',
      styleDialogVisible: false,
      styleDialogActiveTab: '手裁',
      styleDialogActiveType: 'handCut',
      styleDaytime: [],
      styleHandCutData: [],
      styleMaseData: [],
      styleManuData: [],
      styleDialogColumns
    };
  },
  mounted() {
    this.timeScope(1);
  },
  methods: {
    keep1Decimal,
    keepNumber,
    // 导出excel
    exportToExcel() {
      getNoCatch(dataStaticsAPI.excelProcessStatistics, this.getSearchForm()).then(({ data }) => {
        this.helper.downloadItemExcel(data.url, data.fileName);
      });
    },
    getTableData() {
      this.getData();
    },
    // 模块选择变动加载
    changeModule(module) {
      switch (this.activeTab) {
        case '工作量统计':
          this.module = module;
          this.getTableData();
          break;
        case '出错纠错统计':
          this.module2 = module;
          this.$nextTick(() => {
            this.$refs.correctionStatisticsRef.getTableData();
          });
          break;
        case '工作绩效统计':
          this.module = module;
          this.$nextTick(() => {
            this.$refs.performanceStatisticsRef.getTableData();
          });
          break;
      }
    },
    refresh() {
      this.$refs[this.module].$refs.searchTable.resetFields();
      this.daytime = [];
      this.startTime = null;
      this.endTime = null;
      this.getData();
    },
    getSearchForm() {
      let searchForm = cloneDeep(this.$refs[this.module].$refs.searchTable.searchForm);
      searchForm.module = this.activeTab !== '出错纠错统计' ? this.module : this.module2;
      searchForm.stff_name = searchForm?.stff_name || null;
      searchForm.column = searchForm?.column || null;
      searchForm.order = searchForm?.order || null;
      searchForm.dept_name = this.$cookies.get('userInfo').dept_name;
      searchForm.type = 1;
      searchForm.isExport = false;
      const [startTime, endTime] = cloneDeep(this.daytime || []);
      // 确保时间戳被正确赋值且进行单位转换（如果需要）
      searchForm.start_time = startTime ? Math.floor(startTime / 1000) : null;
      let secondDate = new Date(endTime);
      secondDate.setHours(23, 59, 59, 999);
      searchForm.end_time = endTime ? Math.floor(secondDate.getTime() / 1000) : null;
      return searchForm;
    },
    getData() {
      this.loading = true;
      get(dataStaticsAPI.processStatisticssh, this.getSearchForm()).then(({ data }) => {
        if (data.code === 0) {
          this.tableData = data.data.list;
          this.loading = false;
        }
      });
      if (this.module === '手工') {
        this.getDiffListData();
      }
    },
    timeScope(val) {
      let firstDate = new Date();
      firstDate.setMonth(firstDate.getMonth() - val);
      firstDate.setDate(26);
      firstDate.setHours(0, 0, 0, 0);
      let secondDate = new Date();
      secondDate.setDate(25);
      secondDate.setHours(23, 59, 59, 999);
      this.daytime = val === 0 ? [] : [Math.floor(firstDate.getTime()), Math.floor(secondDate.getTime())];
      this.getData();
    },
    openStyleDialog() {
      // 打开式样数据弹窗，默认“上月”范围并加载
      this.styleDialogVisible = true;
      this.$nextTick(() => {
        this.styleTimeScope(1);
      });
    },
    handleStyleTabClick(val) {
      // 页签中文到类型的映射，精简切换逻辑
      const map = { 手裁: 'handCut', 机缝: 'mase', 手工: 'manu' };
      this.styleDialogActiveType = map[this.styleDialogActiveTab];
    },
    getStyleSearchForm(type) {
      // 组装查询参数：独立弹窗时间+当前页签的员工过滤
      const [startTime, endTime] = this.styleDaytime || [];
      const endDate = endTime ? new Date(endTime) : null;
      if (endDate) endDate.setHours(23, 59, 59, 999);
      const refMap = { handCut: 'styleHandCutTable', mase: 'styleMaseTable', manu: 'styleManuTable' };
      const stffName = this.$refs[refMap[type]]?.searchForm?.stff_name || null;
      return {
        start_time: startTime ? Math.floor(startTime / 1000) : null,
        end_time: endTime ? Math.floor(endDate.getTime() / 1000) : null,
        dept_name: this.$cookies.get('userInfo').dept_name,
        stff_name: stffName
      };
    },
    styleTimeScope(val) {
      // 按“26~次月25”规则快速设置时间范围
      let firstDate = new Date();
      firstDate.setMonth(firstDate.getMonth() - val);
      firstDate.setDate(26);
      firstDate.setHours(0, 0, 0, 0);
      let secondDate = new Date();
      secondDate.setDate(25);
      secondDate.setHours(23, 59, 59, 999);
      this.styleDaytime = val === 0 ? [] : [Math.floor(firstDate.getTime()), Math.floor(secondDate.getTime())];
      this.styleGetTableData();
    },
    styleGetTableData(type) {
      // 拉取式样数据；接口一次返回三类，分别赋值
      const queryType = type || this.styleDialogActiveType;
      const params = this.getStyleSearchForm(queryType);
      get(dataStaticsAPI.getStyleScoreData, params).then(({ data }) => {
        if (data.code === 0) {
          const resp = data.data || {};
          this.styleHandCutData = resp.handCut || [];
          this.styleMaseData = resp.mase || [];
          this.styleManuData = resp.manu || [];
        }
      });
    },
    getDiffListData() {
      getNoCatch(dataStaticsAPI.getDiffList).then(({ data }) => {
        this.dialogTableData = data;
      });
    },
    editDiffListData: function () {
      postNoCatch(dataStaticsAPI.editDiffList, this.dialogTableData).then(({ data }) => {
        this.dialogVisible = false;
        this.getData();
        this.$message.success('操作成功!');
      });
    }
  }
};
</script>

<style scoped>
.button-container {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 10px;
  padding: 0;
}
.button-container2 {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
  padding: 0;
}
.jobsBorder {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 100%;
  font-size: 18px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  margin-left: 0 !important;
}

.active-button {
  background-color: #409eff !important;
  color: white !important;
  border-color: #409eff !important;
}

.jobsBorder2 {
  display: inline-block;
  justify-content: center;
  align-items: center;
  height: 70px;
  width: 45%;
  font-size: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.diagramTitle {
  display: flex;
  align-items: center;
}

.dateSelect {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.buttonText {
  font-size: 18px;
}
</style>
